/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components/macro";
import {  NavLink, useNavigate, useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import _ from "lodash";
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator,
} from "@mui/lab";
import {
  CardContent,
  Grid,
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
  Divider as MuiDivider,
  Paper as MuiPaper,
  TextField,
  Typography,
  FormControl,
  Button,
  Chip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import { spacing } from "@mui/system";
import axios from "../../CustomAxios";
import Loading from "../components/Loading";
import moment from "moment";

const Card = styled(MuiCard)(spacing);

const Divider = styled(MuiDivider)(spacing);

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Paper = styled(MuiPaper)(spacing);

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function FormDetails({ apUsers, jobs, auditLogs, task, taskId }) {
  const [err, setErr] = useState("");
  const [loader, setLoader] = useState(false);
  const snackRef = useRef(null);
  //   const [apUsers, setApUsers] = useState(null);
  //   const [jobs, setJobs] = useState(null);

  const [state, setState] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const handleClick = (newState) => () => {
    setState({ open: true, ...newState });
  };


  useEffect(() => {
    console.log(err);
  }, [err]);
  return (
    <>
      <Button
        ref={snackRef}
        style={{ display: "none" }}
        onClick={handleClick({ vertical: "top", horizontal: "center" })}
      >
        Click
      </Button>

      {!loader ? (
        <>
          <Card mb={6}>
            <CardContent>
              <Paper elevation={3} style={{ padding: "2%" }}>
                <Grid container spacing={5}>
                  <Grid item xs={12} lg={12} md={12}>
                    <Typography variant="h6" gutterBottom>
                      View Task
                      <Chip
                        label={task.status.toUpperCase()}
                        color="primary"
                        size="small"
                        sx={{ ml: 2, mb: 1 }}
                      />
                    </Typography>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <Grid container spacing={5}>
                      <Grid item xs={12} md={12} lg={12}>
                        <TextField
                          fullWidth
                          name="title"
                          value={task.title}
                          id="search-field"
                          label="Title * "
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                      </Grid>

                      <Grid item xs={12} lg={12} md={12}>
                        <FormControl fullWidth>
                          <TextField
                            fullWidth
                            name="deadline"
                            value={
                              task.deadline
                                ? moment(task.deadline).calendar()
                                : ""
                            }
                            label="Deadline * "
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} md={12} lg={12}>
                        <FormControl fullWidth>
                          <TextField
                            fullWidth
                            name="assigned_to"
                            value={task?.assigned_to?.name}
                            label="Assigned To "
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <Grid container spacing={3}>
                      <Grid item xs={12} md={12}>
                        <FormControl fullWidth>
                          <TextField
                            fullWidth
                            name="associated_job"
                            value={task.associated_job?.job_id}
                            label="Associated To "
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={12} lg={12}>
                        <TextField
                          fullWidth
                          name="description"
                          multiline
                          rows={5}
                          value={task.description ? task.description : " "}
                          id="search-field"
                          label="Description"
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Paper>
            </CardContent>
          </Card>

          <Card mb={6}>
            <CardContent>
              <Paper elevation={3} style={{ padding: "2%" }}>
                <Grid container spacing={5}>
                  <Grid item xs={12} md={12} lg={12}>
                    <Accordion>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <Typography color="primary" variant="h6" gutterBottom>
                          Audit Logs
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Grid item xs={12} md={12} lg={12}></Grid>
                        <Timeline position="alternate">
                          {auditLogs.map((audit, ind) => {
                            return ind % 2 === 0 ? (
                              <TimelineItem key={ind}>
                                <TimelineOppositeContent
                                  align="right"
                                  variant="body2"
                                  color="secondary"
                                >
                                  <br />
                                  {moment(audit.timestamp).format(
                                    "MMM DD, YYYY"
                                  )}
                                  <br />
                                  {moment(audit.timestamp).format("hh:mm A")}
                                </TimelineOppositeContent>
                                <TimelineSeparator>
                                  <TimelineConnector />
                                  <TimelineDot
                                    color="primary"
                                    variant="outlined"
                                  >
                                    {/* <FastfoodIcon /> */}
                                  </TimelineDot>
                                  <TimelineConnector />
                                </TimelineSeparator>
                                <TimelineContent>
                                  <Typography variant="h6" component="span">
                                    {_.upperCase(audit?.action)}
                                  </Typography>
                                  <Typography variant="body1">
                                    By-
                                    {audit?.user_details?.name || "Super Admin"}
                                  </Typography>
                                  <Typography variant="body2">
                                    {_.upperCase(audit?.user_type) ||
                                      "SUPER ADMIN"}
                                  </Typography>

                                  {audit.description && (
                                    <Typography variant="body2">
                                      Description : {audit?.description}
                                    </Typography>
                                  )}
                                </TimelineContent>
                              </TimelineItem>
                            ) : (
                              <TimelineItem key={ind}>
                                <TimelineOppositeContent
                                  variant="body2"
                                  color="secondary"
                                >
                                  <br />

                                  {moment(audit.timestamp).format(
                                    "MMM DD, YYYY"
                                  )}
                                  <br />
                                  {moment(audit.timestamp).format("hh:mm A")}
                                </TimelineOppositeContent>
                                <TimelineSeparator>
                                  <TimelineConnector />
                                  <TimelineDot color="primary">
                                    {/* <LaptopMacIcon /> */}
                                  </TimelineDot>
                                  <TimelineConnector />
                                </TimelineSeparator>
                                <TimelineContent>
                                  <Typography variant="h6" component="span">
                                    {_.upperCase(audit?.action)}
                                  </Typography>
                                  <Typography variant="body1">
                                    By-{" "}
                                    {audit?.user_details?.name || "Super Admin"}
                                  </Typography>
                                  <Typography variant="body2">
                                    {_.upperCase(audit?.user_type) ||
                                      "SUPER ADMIN"}
                                  </Typography>

                                  {audit.description && (
                                    <Typography variant="body2">
                                      Description : {audit?.description}
                                    </Typography>
                                  )}
                                </TimelineContent>
                              </TimelineItem>
                            );
                          })}
                        </Timeline>
                      </AccordionDetails>
                    </Accordion>
                  </Grid>
                </Grid>
              </Paper>
            </CardContent>
          </Card>
        </>
      ) : (
        <Loading />
      )}
    </>
  );
}

const getTask = async (task_id, setTask, setAuditLogs, setLoader) => {
  try {
    const userData = JSON.parse(localStorage.getItem("AuthData"));
    const config = {
      headers: {
        Authorization: "Bearer " + userData.access_token,
      },
    };

    const task = await axios.get(
      `/api/v1/${userData?.type}/tasks/${task_id}`,
      config
    );
    if (task.data.success) {
      let data = task.data.data;
      if (!data.assigned_to) {
        data.assigned_to = {
          name: "YOURSELF",
          _id: userData.user_id,
        };
      }
      setTask(data);
    }

    let auditLogsUrl = `/api/v1/${userData?.type}/tasks/${task_id}/audit_logs`;

    const auditLogsRes = await axios.get(auditLogsUrl, config);

    if (auditLogsRes.data.success) {
      setAuditLogs(auditLogsRes.data.data.audit_logs);
    }
    setLoader(false);
  } catch (e) {
    setLoader(false);
    console.log(e);
  }
};

function ViewTask() {
  const [loader, setLoader] = useState(true);
  const [task, setTask] = useState(null);
  const [auditLogs, setAuditLogs] = useState([]);
  const { task_id } = useParams();

  useEffect(() => {
    getTask(task_id, setTask, setAuditLogs, setLoader);
  }, []);

  if (!loader) {
    return (
      <React.Fragment>
        <Helmet title="Alpha Plus" />
        <Grid
          justifyContent="space-between"
          alignItems="center"
          container
          spacing={10}
          mb={4}
        >
          <Grid item>
            <Typography
              variant="h4"
              gutterBottom
              display="inline"
              sx={{ fontWeight: 600 }}
              color="primary"
            >
              VIEW TASK
            </Typography>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label="Breadcrumb" mt={2}>
              <Link component={NavLink} to="/dashboard/tasks">
                Dashboard
              </Link>
              <Link component={NavLink} to="/dashboard/tasks">
                Tasks
              </Link>
              <Typography>View Task</Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>

        <Grid container spacing={6}>
          <Grid item xs={12}>
            {task && (
              <FormDetails task={task} auditLogs={auditLogs} taskId={task_id} />
            )}
          </Grid>
        </Grid>
      </React.Fragment>
    );
  } else {
    return <Loading />;
  }
}

export default ViewTask;
